import { SubstitutionPair } from './types';

export { parseResourceName } from '@internal/backstage-plugin-cloudbuild-common';

export const validateBranchName = (branch: string): boolean => {
  // Allows git branch naming with folders (slashes)
  // Rules:
  // - Can contain letters, numbers, underscores, dots, hyphens, and forward slashes
  // - Cannot start or end with slash
  // - Cannot have consecutive slashes
  // - Cannot contain '..' sequence
  const branchRegex =
    /^(?!.*\/\/)(?!.*\.\.)(?!.*\/$)[a-zA-Z0-9_.-]+(?:\/[a-zA-Z0-9_.-]+)*$/;
  return branchRegex.test(branch);
};

export const validateCommitHash = (hash: string): boolean => {
  // Only accepts full sha-1 40 char
  const hashRegex = /^[a-f0-9]{40}$/i;
  return hashRegex.test(hash);
};

export const validateTag = (tag: string): boolean => {
  // Allows most characters except spaces and special Git characters
  const tagRegex = /^[^\s~^:?*[\\\]]+$/;
  return tagRegex.test(tag);
};

export function isValidSubstitutionKey(key: string) {
  // Validate a single substitution key
  const pattern = /^_[A-Z0-9_]+$/;
  return pattern.test(key);
}

export function validateSubstitutions(substitutions: SubstitutionPair[]) {
  // Allow if all substitution keys are valid
  const invalidKeys = substitutions.filter(
    sub => !isValidSubstitutionKey(sub.key),
  );

  if (invalidKeys.length > 0) {
    return {
      isValid: false,
      errors:
        'Substitution keys must start with "_" and contain only uppercase letters, digits, or underscores.',
      invalidKeys,
    };
  }

  return { isValid: true, errors: null };
}

export function createSubstitutionsObject(substitutions: SubstitutionPair[]) {
  return substitutions.reduce((acc, curr) => {
    if (curr.key && curr.value) {
      acc[curr.key] = curr.value;
    }
    return acc;
  }, {} as Record<string, string>);
}
